var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "appointment-calendar" },
    [
      _c("v-date-picker", {
        attrs: {
          "available-dates": _vm.availableDates,
          locale: _vm.locale,
          "disabled-dates": _vm.disabledDates,
        },
        on: { input: _vm.handleOnInput },
        model: {
          value: _vm.selectedDate,
          callback: function ($$v) {
            _vm.selectedDate = $$v
          },
          expression: "selectedDate",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }